/** Match /blog/3 style listing pages (positive integers, no leading zeros). */
export function match(param) {
	return /^[1-9]\d*$/.test(param);
}
